module.exports = __webpack_public_path__ + "static/media/sims_dashboardsidenav_background.2d2e59c6.png";